import React from "react";
import SingleTable from "./SingleTable";
import './DownloadTable.css'
const DownloadTable = () =>{
    const urlBase = "https://files.comip.org.ar/informes/"
    const leftCities= [
        {
            text:"Eldorado",
            download:  urlBase  + "Eldorado.pdf",
        },
        {
            text:"Capitán Meza",
            download:  urlBase  + "Capitán-Meza.pdf",
        },
        {
            text:"Puerto Maní",
            download:  urlBase  + "Puerto-Maní.pdf",
        },
        {
            text:"Posadas",
            download:  urlBase  + "Posadas.pdf",
        },
        {
            text:"San Cosme y Damián",
            download:  urlBase  + "San-Cosme-y-Damián.pdf",
        },
        {
            text:"Ituzaingó",
            download:  urlBase  + "Ituzaingó.pdf",
        },
        {
            text:"Ayolas",
            download:  urlBase  + "Ayolas.pdf",
        },
    ]
    const rightCities= [
        {
            text:"Corateí",
            download:  urlBase  + "Corateí.pdf",
        },
        {
            text:"Itá Ibaté",
            download:  urlBase  + "Itá-Ibaté.pdf",
        },
        {
            text:"Cerrito",
            download:  urlBase  + "Cerrito.pdf",
        },
        {
            text:"Itatí",
            download:  urlBase  + "Itatí.pdf",
        },
        {
            text:"Itá Corá",
            download:  urlBase  + "Itá-Corá.pdf",
        },
        {
            text:"Paso de la Patria",
            download:  urlBase  + "Paso-de-la-Patria.pdf",
        },
        {
            text:".",
            download:"",
        },
    ]
    return(
        <>
            <div className="dl-table-container" >
                <SingleTable list={leftCities} />
                <SingleTable list={rightCities} />
            </div>
        </>
    )
}

export default DownloadTable